import React from 'react'

import { Field } from 'formik'

import { ZariContext } from '_zari/context'
import { Col, Form } from '_zari/core'

import * as ProyectoService from 'services/proyecto.service'

const ProyectoFormGroup = ({ iError, iTouched, fIsSubmitting, handleChange, setFieldValue }) => {
  const __zariContext = React.useContext(ZariContext)

  const [listaProyectos, setListaProyectos] = React.useState([])

  const onChange = React.useCallback(
    e => {
      handleChange(e)

      const nuevoValor = e.target.value

      if (nuevoValor) {
        const matchProyecto = listaProyectos.find(x => x._id === nuevoValor)
        setFieldValue('moneda', matchProyecto.moneda)
      } else {
        setFieldValue('moneda', '')
      }
    },
    [handleChange, setFieldValue, listaProyectos]
  )

  React.useEffect(() => {
    ProyectoService.obtenerAsSelect()
      .then(({ data }) => {
        setListaProyectos(data)
      })
      .catch(({ data: { error } }) => {
        __zariContext.snack('error', error)
        setListaProyectos([])
      })
  }, [__zariContext])

  return (
    <>
      <Form.Group>
        <Form.Label text='PROYECTO' htmlFor='select-_idProyecto' md={12} />
        <Col md={12}>
          <Field name='_idProyecto'>
            {({ field }) => (
              <Form.Select
                {...field}
                id='select-_idProyecto'
                isInvalid={iTouched && iError}
                disabled={fIsSubmitting}
                onChange={onChange}
              >
                <option value=''>Seleccionar</option>
                {listaProyectos.map((x, k) => (
                  <option key={k} value={x._id}>
                    {x.descripcion}
                  </option>
                ))}
              </Form.Select>
            )}
          </Field>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(ProyectoFormGroup)
